import { takeEvery } from 'redux-saga'
import { put, select, call } from 'redux-saga/effects'
import { COPY_MULTI_IMAGER } from 'actions/multiImagerActionTypes'
import { copyCameraSelector } from 'selectors'
import { duplicateCameraAction, addRecentModelAction } from 'actions/cameraActions'
import { duplicateMultiImagerLensAction } from 'actions/multiImagerActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import determineLocationOfNewDevice from 'helpers/map/determineLocationOfNewDevice'
import chooseNextProperId from 'helpers/chooseNextProperId'

export function * copyMultiImager(action) {
  try {
    const { cameras, map, isImperial, devices } = yield select(copyCameraSelector)

    const location = yield call(determineLocationOfNewDevice, { map, devices, isImperial })
    const camera = cameras.find(c => c.id === action.id)
    const { lensIds, fixedLensIds } = camera

    const cameraIds = cameras.map(c => c.id)
    const newId = yield call(chooseNextProperId, cameraIds)

    let childLensIds = []
    let childFixedLensIds = []

    for (let i = 0; i < lensIds.length; i++) {
      const childId = yield call(chooseNextProperId, [...cameraIds, newId, ...childLensIds])
      childLensIds[i] = childId
      yield put(duplicateMultiImagerLensAction(lensIds[i], location, childId, newId))

      if (fixedLensIds && fixedLensIds.includes(lensIds[i])) childFixedLensIds.push(childId)
    }    

    yield put(duplicateCameraAction(action.id, location, newId, childLensIds, childFixedLensIds))

    if (camera && camera.model) {
      yield put(addRecentModelAction(camera.model.id, Date.now()))
    }
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for copy multi imager action, then call function */
export function * watchCopyMultiImager() {
  yield * takeEvery(COPY_MULTI_IMAGER, copyMultiImager)
}



// WEBPACK FOOTER //
// ./src/sagas/copyMultiImagerSaga.js